/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EliosPhotoStatus } from '../models/EliosPhotoStatus';
import type { PaginatedEliosPhotoStatusList } from '../models/PaginatedEliosPhotoStatusList';
import type { PatchedEliosPhotoStatus } from '../models/PatchedEliosPhotoStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsEliosPhotoStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedEliosPhotoStatusList
     * @throws ApiError
     */
    public clientsEliosPhotoStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedEliosPhotoStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-elios-photo-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns EliosPhotoStatus
     * @throws ApiError
     */
    public clientsEliosPhotoStatusCreate({
        requestBody,
    }: {
        requestBody: EliosPhotoStatus,
    }): CancelablePromise<EliosPhotoStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-elios-photo-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EliosPhotoStatus
     * @throws ApiError
     */
    public clientsEliosPhotoStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this elios photo status.
         */
        id: number,
    }): CancelablePromise<EliosPhotoStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-elios-photo-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns EliosPhotoStatus
     * @throws ApiError
     */
    public clientsEliosPhotoStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this elios photo status.
         */
        id: number,
        requestBody: EliosPhotoStatus,
    }): CancelablePromise<EliosPhotoStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-elios-photo-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EliosPhotoStatus
     * @throws ApiError
     */
    public clientsEliosPhotoStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this elios photo status.
         */
        id: number,
        requestBody?: PatchedEliosPhotoStatus,
    }): CancelablePromise<EliosPhotoStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-elios-photo-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsEliosPhotoStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this elios photo status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-elios-photo-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
